import { Directive } from '@angular/core';
@Directive({
  selector: '[fAlertsContainer]',
  standalone: false
})
export class AlertsContainerDirective {}
